import React from 'react';
import { isMobile } from 'react-device-detect';
import type { Dayjs } from 'dayjs';

interface WeeklyReportHeaderProps {
  onPreviousDay: () => void;
  onNextDay: () => void;
  isNextDayDisabled: boolean;
  isPreviousDayDisabled: boolean;
  currentDate: Dayjs;
}

const WeeklyReportHeader: React.FC<WeeklyReportHeaderProps> = ({
  onPreviousDay,
  onNextDay,
  isNextDayDisabled,
  isPreviousDayDisabled,
  currentDate,
}) => {
  const label = currentDate.format('MMMM DD, YYYY');

  return isMobile ? (
    <div className='fixed top-0 left-0 right-0 p-5 flex items-center justify-between gap-3 bg-black z-[999] w-full'>
      <button
        className='flex-shrink-0 flex items-center justify-center w-7 h-7 p-2 bg-transparent text-[#949494] rounded cursor-pointer transition-all disabled:opacity-40 disabled:cursor-not-allowed'
        onClick={onPreviousDay}
        disabled={isPreviousDayDisabled}
      >
        <img
          src='/svg/left-arrow.svg'
          alt='Previous Day'
          className='w-2.5 h-3.5'
        />
      </button>
      <p className='opacity-80 text-white text-xl font-bold'>{label}</p>
      <button
        className='flex-shrink-0 flex items-center justify-center w-7 h-7 p-2 bg-transparent text-[#949494] rounded cursor-pointer transition-all disabled:opacity-40 disabled:cursor-not-allowed'
        onClick={onNextDay}
        disabled={isNextDayDisabled}
      >
        <img
          src='/svg/left-arrow.svg'
          alt='Next Day'
          className='w-2.5 h-3.5 rotate-180'
        />
      </button>
    </div>
  ) : (
    <header className='bg-black text-white'>
      <div className='max-w-[1400px] mx-auto flex justify-end items-center flex-wrap gap-5 px-5 sticky top-0 z-[999]'>
        <div className='flex flex-col mr-auto'>
          <p className='text-[30px] font-bold mb-0.5'>SpaceMap Daily Report</p>
          <p className='opacity-80 text-white text-xl font-bold'>{label}</p>
        </div>
        <div className='p-5 flex items-center justify-center gap-3 flex-nowrap'>
          <button
            className='flex-shrink-0 flex items-center justify-center w-10 h-8 p-2 bg-transparent text-[#949494] rounded cursor-pointer transition-all disabled:opacity-40 disabled:cursor-not-allowed'
            onClick={onPreviousDay}
            disabled={isPreviousDayDisabled}
          >
            <img
              src='/svg/left-arrow.svg'
              alt='Previous Day'
              className='w-4 h-4'
            />
          </button>
          <button
            className='flex-shrink-0 flex items-center justify-center w-10 h-8 p-2 bg-transparent text-[#949494] rounded cursor-pointer transition-all disabled:opacity-40 disabled:cursor-not-allowed'
            onClick={onNextDay}
            disabled={isNextDayDisabled}
          >
            <img
              src='/svg/left-arrow.svg'
              alt='Next Day'
              className='w-4 h-4 rotate-180'
            />
          </button>
        </div>
      </div>
    </header>
  );
};

export default WeeklyReportHeader;
